/**
 *
 * @param {Date} date
 * @returns {Date}
 */
export const convertUTCToLocalDate = (date) => {
  if (!date) {
    return date;
  }
  const convertedDate = new Date(date);
  const offset = convertedDate.getTimezoneOffset(); // in minutes

  convertedDate.setMinutes(convertedDate.getMinutes() + offset);
  convertedDate.setHours(12, 0, 0, 0);

  return convertedDate;
};
/**
 *
 * @param {Date} date
 * @returns {Date}
 */
export const convertLocalToUTCDate = (date) => {
  if (!date) {
    return date;
  }
  const convertedDate = new Date(date);
  convertedDate.setHours(12, 0, 0, 0);

  return new Date(
    Date.UTC(
      convertedDate.getFullYear(),
      convertedDate.getMonth(),
      convertedDate.getDate(),
      12,
      0,
      0,
      0,
    ),
  );
};
